import clsx from 'clsx';

import { twMerge } from 'utils/twMerge';
import type { ClickableProps } from '../Clickable';
import Clickable from '../Clickable';
import { ArrowLeftIcon } from '../Icons';

const BackButton = ({ className, ...restProps }: ClickableProps) => {
  return (
    <Clickable
      className={twMerge(
        clsx(
          'flex shrink-0 items-center justify-center mr-sm3 h-[40px] w-[40px]',
          className,
        ),
      )}
      hoverSize="md"
      hoverTargetColor="backgroundAccent"
      hoverTarget={true}
      {...restProps}
    >
      <ArrowLeftIcon />
    </Clickable>
  );
};

export default BackButton;
